export const ZODIAC_SIGNS = [
  {
    name: "Aries",
    symbol: "♈\uFE0E",
    dates: "Mar 21 – Apr 19",
    description: "Bold and quick to act, Aries charges toward whatever ignites its fire. Born leaders who chase firsts.",
  },
  {
    name: "Taurus",
    symbol: "♉\uFE0E",
    dates: "Apr 20 – May 20",
    description: "Grounded and steady, Taurus seeks comfort, beauty and things built to last. Loyal to the core.",
  },
  {
    name: "Gemini",
    symbol: "♊\uFE0E",
    dates: "May 21 – Jun 20",
    description: "Curious and quick-witted, Gemini thrives on conversation and change. Never short of a new idea.",
  },
  {
    name: "Cancer",
    symbol: "♋\uFE0E",
    dates: "Jun 21 – Jul 22",
    description: "Deeply intuitive and protective, Cancer leads with feeling. Home is wherever the heart feels safe.",
  },
  {
    name: "Leo",
    symbol: "♌\uFE0E",
    dates: "Jul 23 – Aug 22",
    description: "Warm and magnetic, Leo was born to be seen. Generous, proud, and fiercely loyal to its own.",
  },
  {
    name: "Virgo",
    symbol: "♍\uFE0E",
    dates: "Aug 23 – Sep 22",
    description: "Precise and devoted, Virgo finds meaning in the details others miss. Quietly, endlessly useful.",
  },
  {
    name: "Libra",
    symbol: "♎\uFE0E",
    dates: "Sep 23 – Oct 22",
    description: "Charming and fair-minded, Libra seeks balance in every room. A natural diplomat and romantic.",
  },
  {
    name: "Scorpio",
    symbol: "♏\uFE0E",
    dates: "Oct 23 – Nov 21",
    description: "Intense and magnetic, Scorpio feels everything at full volume. Fiercely private, fiercely loyal.",
  },
  {
    name: "Sagittarius",
    symbol: "♐\uFE0E",
    dates: "Nov 22 – Dec 21",
    description: "Restless and philosophical, Sagittarius chases horizons. Freedom-loving and endlessly optimistic.",
  },
  {
    name: "Capricorn",
    symbol: "♑\uFE0E",
    dates: "Dec 22 – Jan 19",
    description: "Disciplined and ambitious, Capricorn builds for the long run. Patient, practical, quietly unstoppable.",
  },
  {
    name: "Aquarius",
    symbol: "♒\uFE0E",
    dates: "Jan 20 – Feb 18",
    description: "Independent and visionary, Aquarius marches to its own rhythm. An idealist with a rebel streak.",
  },
  {
    name: "Pisces",
    symbol: "♓\uFE0E",
    dates: "Feb 19 – Mar 20",
    description: "Dreamy and empathetic, Pisces absorbs the world's feelings as its own. Artistic, intuitive, boundless.",
  },
];
